import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5666%3A118
 *
 * @param {SvgIconProps} props - svg props
 */
export const SignoutIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M12 21.9999C17.5228 21.9999 22 17.5227 22 11.9999C22 7.67688 19.2568 3.99455 15.4162 2.59863C15.4701 2.72146 15.5 2.85719 15.5 2.9999V5.93637C17.5923 7.14671 19 9.40891 19 11.9999C19 15.8659 15.866 18.9999 12 18.9999C8.13401 18.9999 5 15.8659 5 11.9999C5 9.40891 6.40769 7.14671 8.5 5.93637V2.9999C8.5 2.85719 8.52989 2.72146 8.58376 2.59863C4.74315 3.99455 2 7.67688 2 11.9999C2 17.5227 6.47715 21.9999 12 21.9999Z' fill={color}/>
            <rect x='10.5' y='1.5' width='3' height='10' rx='1.5' fill={color}/>
        </SvgIcon>
    )
}

export default SignoutIcon
